import { IMockCategoryData } from "./Category";

const MockCategoryData: IMockCategoryData[] = [
  { name: "Main", dataId: 1 },
  { name: "Casino", dataId: 2 },
];

export { MockCategoryData };
